// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lineChart[data-v-95e5d68e] {\n  width: 100%;\n  height: 400px;\n}", ""]);
// Exports
module.exports = exports;
